import React from 'react';

function Footer() {
    return (
        <div className={"center text-center"}>
            <ul className={"footerlist"}>
                <li style={{display: "inline"}}><a href={"/"}>Rejestracja</a></li>
                <li style={{display: "inline"}}> | </li>
              <li style={{display: "inline"}}><a href={"/kontakt"}>Kontakt</a></li>
              <li style={{display: "inline"}}> | </li>
                <li style={{display: "inline"}}><a href={"/warunki"}>Polityka prywatności i Regulamin</a></li>
            </ul>
            <p className={"center text-center"}> ❤️ Warszawe </p>
            <a className={"center text-center"} href="https://www.flaticon.com/free-icons/recycle-bin"
               title="ikonka kosza">Ikona kosza
                od lakonicon - Flaticon</a>
        </div>
    );
}

export default Footer;
